export function selectActivePageId({ router }) {
  return router.location?.match?.params?.pageId
}